import React, { Component } from 'react';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import { APPLICATION_STATUS } from '../../config/GBConstants';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import DecisionDeclined from './DecisionDeclined';
import DecisionApproved from './DecisionApproved';

import '../../styles/base-gb.less';
import _ from 'lodash';


export class DecisionPage extends Component {
    static propTypes = {
        applicationStatus: PropTypes.string.isRequired,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        onComponentDidMount: PropTypes.func.isRequired
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        const {
            applicationStatus,
            flow
        } = this.props;

        return (
            <div className="outerWrapper gb-wrapper">
                <div id="wrapper">
                    <div id="main">
                        <div id="DecisionPage">
                            {(flow !== FLOW_TYPE.TESLA) && <Header singleColumnLayout={true} />}
                            {(applicationStatus === APPLICATION_STATUS.APPROVED) ? <DecisionApproved /> : <DecisionDeclined />}
                        </div>
                    </div>
                </div>
                <StickyFooter fixToBottom={false} fadedBackground={true}>
                    <Footer showCancelUrl={false} />
                </StickyFooter>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    applicationStatus: _.get(
        state,
        'serverData.decisionModel.applicationStatus',
        'unknownStatus'
    ),
    flow: _.get(state, 'serverData.flow')
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_decisionpage', 'prepare_pp_credit_decisionpage'));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(DecisionPage);
